<script>

import { allKommunesData } from '../utils/apiStore';


</script>

<style lang="scss">
  .kommunetable {
    display: flex;
    /* flex-direction: column; */
    flex-wrap: wrap;
    margin-top: 1rem;
    gap: 4px;
    
    .kommune-badge {
      padding: 6px 12px;
      background-color: color(background-07);
      width: fit-content;
      @include desktop{
        padding: 6px 8px;
      }
      &:hover {
        background-color: color(background-dark);
      }
    }
  }
</style>

<div class="kommunetable">
  {#if $allKommunesData}
    {#each Object.values($allKommunesData) as kommune}
      <a class="kommune-badge" href="#/kommune/{kommune.name}">{kommune.name}</a>
    {/each}
  {/if}
</div> 

